module.exports = {
    "main": {
        "site_id": 18753111,
        "title": "MamboBet",
        "source": 99,
        "availableLanguages": {
            'eng': {
                'short': 'EN',
                'full': "English",
                'region': "UnitedKingdom",
                "order": 2
            },
        },
        "disableGeoLocationLanguage": true,
        "disableAddEventsFromSameGame": true,
        "showSportsbookInterfaceSettings": false,
        "enableTabletVersion": true,
        "enableRuntimePopup": false,
        "popularGamesCount": 5,
        "video": {
            "availableVideoProviderIds": [1, 3, 5, 16, 19]
        },
        "currencyRounding": 3,
        "googleAnalyticsId": 'UA-29242337-7'
    },
    "swarm": {
        "debugging": false, //enable websocket debugging
        "languageMap": {
            "pol": "eng",
            "por": "por_2",
            "pt-br": "por",
            "fre": "fra",
            "chi": "chn",
            "mac": "mkd",
            "bgr": "bul",
            "lat": "lav",
            "fas": "far",
            "rum": "ron"
        },
        "sendSourceInRequestSession": true,
        "sendTerminalIdlInRequestSession": false,
        "webSocketTimeout": 10000,
        "url": [{
            "url": "https://eu-swarm-betshops-lp.betconstruct.com"
        }],
        "websocket": [ {
            "url": "wss://mrg-swarm-betshops-ws.betconstruct.com/"

        }],
        "useWebSocket": true,
        "maxWebsocketRetries": 100, // maximum number of websocket reconnect attempts after which it will give up
        "webSocketRetryInterval": 2000 // retry interval, in milliseconds (will be increased after each unsuccessful retry by itself)
    },
    "virtualGames": {
        'enabled': true,
        'videoInUpperscreen': true,
        "providers": {
            "Betconstruct": {
                "name": "Betconstruct",
                "id": 15
            }
            // "Inspired": {
            //     "name": "Inspired",
            //     "id": 29
            // }
        }
    },
    "casino": {
        "games": {
            "loaderStep": 28
        }
    },
    "liveCasino": {
        "games": {
            "loaderStep": 21
        }
    },
    "env": {
        "lang": "fra",
        "oddsFormat": "decimal"
    },

    "betting": {
        
        "enableBookingBet": false,
        "totalOddsMax": 10000
    },
    //"rulesURL": "https://newbettingterminal-bc.betconstruct.com/rules/bcrules.pdf",
    "terminal": {
        "asianViewEnabled": true,
        "scrollButtons": true,
        "setGameListDropDown": false,
        "printUserBet": true,
        "disableLiveGamesInToday": true,
        "enableSignOutWithRfidButton": false,
        "asianViewTwoImportantMarkets": false,
        "signInToAdmin": false
    },
    "enableDraggable": true,
    "setDefaultBetSlipSettingType": true,
    "betslipInHomePage": true,
    "financialButtons": [
        "Last entered bills and coins",
        "Stacker Balance",
        "Todays Report",
        "Encashment"
    ],

    "openSectionNameOnClick": true,
    "colorForTimer": "#C80000",
    "headerItems": [
        {
            "url": "prematch",
            "name": "Prematch",
            'enabled': true
        },
        {
            "url": "live",
            "name": "Live",
            'enabled': true
        },
        {
            "url": "today",
            "name": "Today",
            'enabled': true
        },
        {
            "url": "virtualGames",
            "name": "Virtual Games",
            'enabled': true
        },
        {
            "url": "casino",
            "name": "Casino",
            'enabled': true
        },
        {
            "url": "dealer",
            "name": "Live Casino",
            'enabled': true
        },
        {
            "url": "realHorseRacing",
            "name": "Real Horse Racing",
            'enabled': false
        }
    ],
    "statisticsButton": true,
    "setOnlyBetcoGames": true,
    "homePageView": 5,
    "homePageCompetitionsCount": 7,
    "enableTopGames": true,
    "searchInHeader": true,
    "showGameNumber": true,
    "homePageHorseRacing": false,
    "enableLiveClock": true,
    "defaultTerminalParams": {pid: 18753111, tid: 27242, token: "pHw2Cg==", currency: 'USD'},
    "staticStake": true,
    "enableLogoOnPopups": false,
    "useCurrencySymbol": false,
    "urlForDualScreenStatistics": "https://statistics.betconstruct.com/#/",
    "staticStakeCounts": { default: [50, 100, 200, 500, 1000] },
    "popupForTerminalInactivity": true,
    'asianViewMarket': {
        'Soccer': {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "side": ["P1", "X", "P2"]
                    },
                    {
                        "display_key": "DOUBLE CHANCE",
                        "title": "DOUBLE CHANCE",
                        "side": ["1X", "12", "X2"]
                    },
                    {
                        "display_key": "NEXTGOALTOSCORE",
                        "title": "NEXT GOAL TO SCORE",
                        "side": ["Home", "No", "Away"]
                    }
                ], [
                    {
                        "display_key": "BOTHTEAMTOSCORE",
                        "title": "Both Team To Score",
                        "side": ["Yes", "No"]
                    },
                    {
                        "display_key": "DRAWNOBET",
                        "title": "Draw No Bet",
                        "side": ["Team1", "Team2"]
                    }
                ], [
                    {
                        "display_key": "HANDICAP",
                        "market_type": { "@in": ["AsianHandicap", "HalfTimeAsianHandicap", "2ndHalfAsianHandicap"] },
                        "title": "Handicap",
                        "side": ["Home", "Away"],
                        "main_order": { "@in": [1, 2] }
                    },
                    {
                        "display_key": "HANDICAP",
                        "market_type": { "@in": ["AsianHandicapAsian", "HalfTimeAsianHandicapAsian", "2ndHalfAsianHandicapAsian"] },
                        "title": "Asian Handicap",
                        "side": ["Home", "Away"],
                        "main_order": { "@in": [1, 2] }
                    }
                ], [
                    {
                        "display_key": "TOTALS",
                        "market_type": { "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"] },
                        "title": "Total Goals 1.5",
                        "side": ["Over", "Under"],
                        "base": 1.5
                    },
                    {
                        "display_key": "TOTALS",
                        "market_type": { "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"] },
                        "title": "Total Goals 2.5",
                        "side": ["Over", "Under"],
                        "base": 2.5
                    },
                    {
                        "display_key": "TOTALS",
                        "market_type": { "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"] },
                        "title": "Total Goals 3.5",
                        "side": ["Over", "Under"],
                        "base": 3.5
                    },
                    {
                        "display_key": "TOTALS",
                        "market_type": { "@in": ["OverUnderAsian", "HalfTimeOverUnderAsian", "2ndHalfTotalOver/UnderAsian"] },
                        "title": "Total Goals Asian",
                        "side": ["Over", "Under"]
                    },
                    {
                        "display_key": "CARDSTOTALS",
                        "title": "Yellow Cards: Total",
                        "side": ["Over", "Under"]
                    },
                    {
                        "display_key": "ODD/EVEN",
                        "market_type": { "@in": ["EvenOddTotal", "FirstHalfEvenOddTotal", "SecondHalfEvenOddTotal"] },
                        "title": "Total Goals: Even/Odd",
                        "side": ["Even", "Odd"]
                    }
                ]
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "side": ["P1", "X", "P2"]
                    },
                    {
                        "display_key": "DOUBLE CHANCE",
                        "title": "DOUBLE CHANCE",
                        "side": ["1X", "12", "X2"]
                    }
                ], [
                    {
                        "display_key": "BOTHTEAMTOSCORE",
                        "title": "Both Team To Score",
                        "side": ["Yes", "No"]
                    },
                    {
                        "display_key": "DRAWNOBET",
                        "title": "Draw No Bet",
                        "side": ["Team1", "Team2"]
                    }
                ], [
                    {
                        "display_key": "HANDICAP",
                        "market_type": { "@in": ["AsianHandicap", "HalfTimeAsianHandicap", "2ndHalfAsianHandicap"] },
                        "title": "Handicap",
                        "side": ["Home", "Away"],
                        "main_order": { "@in": [1, 2] }
                    },
                    {
                        "display_key": "HANDICAP",
                        "market_type": { "@in": ["AsianHandicapAsian", "HalfTimeAsianHandicapAsian", "2ndHalfAsianHandicapAsian"] },
                        "title": "Asian Handicap",
                        "side": ["Home", "Away"],
                        "main_order": { "@in": [1, 2] }
                    }
                ], [
                    {
                        "display_key": "TOTALS",
                        "market_type": { "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"] },
                        "title": "Total Goals 1.5",
                        "side": ["Over", "Under"],
                        "base": 1.5
                    },
                    {
                        "display_key": "TOTALS",
                        "market_type": { "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"] },
                        "title": "Total Goals 2.5",
                        "side": ["Over", "Under"],
                        "base": 2.5
                    },
                    {
                        "display_key": "TOTALS",
                        "market_type": { "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"] },
                        "title": "Total Goals 3.5",
                        "side": ["Over", "Under"],
                        "base": 3.5
                    },
                    {
                        "display_key": "TOTALS",
                        "market_type": { "@in": ["OverUnderAsian", "HalfTimeOverUnderAsian", "2ndHalfTotalOver/UnderAsian"] },
                        "title": "Total Goals Asian",
                        "side": ["Over", "Under"]
                    },
                    {
                        "display_key": "CARDSTOTALS",
                        "title": "Yellow Cards: Total",
                        "side": ["Over", "Under"]
                    },
                    {
                        "display_key": "ODD/EVEN",
                        "market_type": { "@in": ["EvenOddTotal", "FirstHalfEvenOddTotal", "SecondHalfEvenOddTotal"] },
                        "title": "Total Goals: Even/Odd",
                        "side": ["Even", "Odd"]
                    }
                ]
            ]
        },
        "Tennis": {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "side": ["P1", "P2"]
                    }
                ],
                [
                    {
                        "market_type": "SetHandicap",
                        "title": "Set Handicap",
                        "side": ["Home", "Away"]
                    }
                ],
                [
                    // {
                    //     "market_type": { "@in": ["TotalofMatchPoints", "SetTotalPoints"] },
                    //     "title": "Total Points",
                    //     "side": ["Over", "Under"]
                    // },
                    {
                        "display_key": "TOTALS",
                        "market_type": { "@in": ["SetOverUnder", "TotalGamesOver/Under"] },
                        "title": "Total Games",
                        "side": ["Over", "Under"]
                    }
                    //todo: we need following markets
                    //{X} Set {Y} Game Winner market
                    //{X} Set {Y} Game Handicap Points
                ],
                [
                    {
                        "market_type": { "@in": ["TotalGamesOddorEven", "SetTotalGamesOddEven"] },
                        "title": "Total Games Odd or Even",
                        "side": ["Even", "Odd"]
                    }
                ]
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "side": ["P1", "P2"]
                    }
                ],
                [
                    {
                        "market_type": "SetHandicap",
                        "title": "Set Handicap",
                        "side": ["Home", "Away"]
                    }
                ],
                [
                    // {
                    //     "market_type": { "@in": ["TotalofMatchPoints", "SetTotalPoints"] },
                    //     "title": "Total Points",
                    //     "side": ["Over", "Under"]
                    // },
                    {
                        "display_key": "TOTALS",
                        "market_type": { "@in": ["SetOverUnder", "TotalGamesOver/Under"] },
                        "title": "Total Games",
                        "side": ["Over", "Under"]
                    }
                    //todo: we need following markets
                    //{X} Set {Y} Game Winner market
                    //{X} Set {Y} Game Handicap Points
                ],
                [
                    {
                        "market_type": { "@in": ["TotalGamesOddorEven", "SetTotalGamesOddEven"] },
                        "title": "Total Games Odd or Even",
                        "side": ["Even", "Odd"]
                    }
                ]
            ]
        },
        "Basketball": {
            "live": [
                [
                    {
                        "market_type": { "@in": ["MatchWinner3", "QuarterWinner3", "HalfWinner3"] },
                        "title": "Winner 3 way",
                        "col_count": 3,
                        "side": ["P1", "X", "P2"]
                    }
                ], [
                    {
                        "display_key": "WINNER",
                        "title": "Winner 2 Way",
                        "col_count": 2,
                        "side": ["P1", "P2"]
                    }, {
                        "title": "Overtime",
                        "market_type": "Overtime",
                        "side": ["P1", "P2"]
                    }
                ], [
                    {
                        "display_key": "TOTALS",
                        "title": "Match Total",
                        "side": ["Over", "Under"]
                    }, {
                        "display_key": "ODD/EVEN",
                        "title": "Match Total Odd/Even",
                        "side": ["Even", "Odd"]
                    }
                ],
                [
                    {
                        "display_key": "HANDICAP",
                        "title": "Match Handicap",
                        "side": ["Home", "Away"]
                    }
                ]
            ],
            "prematch": [
                [
                    {
                        "market_type": { "@in": ["MatchWinner3", "QuarterWinner3", "HalfWinner3"] },
                        "title": "Winner 3 way",
                        "col_count": 3,
                        "side": ["P1", "X", "P2"]
                    }
                ], [
                    {
                        "display_key": "WINNER",
                        "title": "Winner 2 Way",
                        "col_count": 2,
                        "side": ["P1", "P2"]
                    }, {
                        "title": "Overtime",
                        "market_type": "Overtime",
                        "side": ["P1", "P2"]
                    }
                ],
                [
                    {
                        "display_key": "TOTALS",
                        "title": "Match Total",
                        "side": ["Over", "Under"]
                    }, {
                        "display_key": "ODD/EVEN",
                        "title": "Match Total Odd/Even",
                        "side": ["Even", "Odd"]
                    }
                ],
                [
                    {
                        "display_key": "HANDICAP",
                        "title": "Match Handicap",
                        "side": ["Home", "Away"]
                    }
                ]
            ]
        },
        "IceHockey": {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "Winner (Regular Time)",
                        "col_count": 3,
                        "side": ["P1", "X", "P2"]
                    },
                    {
                        "display_key": "DOUBLE CHANCE",
                        "title": "Double chance (Regular Time)",
                        "side": ["1X", "12", "X2"]
                    },
                    {
                        "market_type": "NextTeamToScore",       //todo: check this market when games are live
                        "title": "Next Team to Score",
                        "side": ["Home", "Away", "No"]
                    }
                ],
                [
                    {
                        "display_key": "WINNER",
                        "title": "Winner (With Overtime)",
                        "market_type": "MatchWinner2",
                        "side": ["P1", "P2"]
                    },
                    {
                        "display_key": "BOTHTEAMTOSCORE",
                        "title": "Both Team To Score",
                        "side": ["Yes", "No"]
                    }
                ],
                [
                    {
                        "market_type": { "@in": ["MatchTotal3", "PeriodTotal3"] }, // there is no PeriodTotal3, leave for the future
                        "display_key": "TOTALS",
                        "title": "Total 3 Way (Regular Time)",
                        "side": ["Over", "Exactly", "Under"]
                    }
                ],
                [
                    {
                        "market_type": { "@in": ["MatchTotal2", "PeriodTotal2"] },
                        "display_key": "TOTALS",
                        "title": "Total (Regular Time)",
                        "side": ["Over", "Under"]
                    },
                    // {
                    //     "market_type": { "@in": ["MatchTotal2Asian", "PeriodTotal2Asian"] },
                    //     "display_key": "TOTALS",
                    //     "title": "Asian Total (Regular Time)",
                    //     "side": ["Over", "Under"]
                    // },
                    {
                        "market_type": { "@in": ["MatchHandicap2", "PeriodHandicap2"] },
                        "display_key": "HANDICAP",
                        "title": "Handicap (Regular Time)",
                        "side": ["Home", "Away"]
                    }
                    // {
                    //     "market_type": { "@in": ["MatchHandicap2Asian", "PeriodHandicap2Asian"] },
                    //     "display_key": "HANDICAP",
                    //     "title": "Asian Handicap (Regular Time)",
                    //     "side": ["Home", "Away"]
                    // }
                    //odd even apush market Khcoi asac chenq drel
                ]
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "Winner (Regular Time)",
                        "col_count": 3,
                        "side": ["P1", "X", "P2"]
                    },
                    {
                        "display_key": "DOUBLE CHANCE",
                        "title": "Double chance (Regular Time)",
                        "side": ["1X", "12", "X2"]
                    }
                ],
                [
                    {
                        "display_key": "WINNER",
                        "title": "Winner (With Overtime)",
                        "market_type": "MatchWinner2",
                        "side": ["P1", "P2"]
                    },
                    {
                        "display_key": "BOTHTEAMTOSCORE",
                        "title": "Both Team To Score",
                        "side": ["Yes", "No"]
                    }
                ],
                [
                    {
                        "market_type": { "@in": ["MatchTotal3", "PeriodTotal3"] }, // there is no PeriodTotal3, leave for the future
                        "display_key": "TOTALS",
                        "title": "Total 3 Way (Regular Time)",
                        "side": ["Over", "Exactly", "Under"]
                    }
                ],
                [
                    {
                        "market_type": { "@in": ["MatchTotal2", "PeriodTotal2"] },
                        "display_key": "TOTALS",
                        "title": "Total (Regular Time)",
                        "side": ["Over", "Under"]
                    },
                    // {
                    //     "market_type": { "@in": ["MatchTotal2Asian", "PeriodTotal2Asian"] },
                    //     "display_key": "TOTALS",
                    //     "title": "Asian Total (Regular Time)",
                    //     "side": ["Over", "Under"]
                    // },
                    {
                        "market_type": { "@in": ["MatchHandicap2", "PeriodHandicap2"] },
                        "display_key": "HANDICAP",
                        "title": "Handicap (Regular Time)",
                        "side": ["Home", "Away"]
                    }
                    // {
                    //     "market_type": { "@in": ["MatchHandicap2Asian", "PeriodHandicap2Asian"] },
                    //     "display_key": "HANDICAP",
                    //     "title": "Asian Handicap (Regular Time)",
                    //     "side": ["Home", "Away"]
                    // }
                    //odd even apush market Khcoi asac chenq drel
                ]
            ]
        },
        "Volleyball": {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "Winner",
                        "side": ["P1", "P2"]
                    }
                ],
                [
                    {
                        "market_type": "HANDICAP",       //todo: check this market when games are live
                        "title": "Match points Handicap",
                        "side": ["Home", "Away"]
                    }
                ],
                [
                    {
                        "market_type": "TOTALS",       //todo: check this market when games are live
                        "title": "Total points",
                        "side": ["Home", "Away"]
                    }
                ],
                [
                    {
                        "market_type": { "@in": ["MatchHandicap2", "PeriodHandicap2"] },
                        "display_key": "HANDICAP",
                        "title": "Handicap (Regular Time)",
                        "side": ["Home", "Away"]
                    }
                ]
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "Winner",
                        "side": ["P1", "P2"]
                    }
                ],
                [
                    {
                        "market_type": "HANDICAP",       //todo: check this market when games are live
                        "title": "Match points Handicap",
                        "side": ["Home", "Away"]
                    }
                ],
                [
                    {
                        "market_type": "TOTALS",       //todo: check this market when games are live
                        "title": "Total points",
                        "side": ["Home", "Away"]
                    }
                ],
                [
                    {
                        "market_type": { "@in": ["MatchHandicap2", "PeriodHandicap2"] },
                        "display_key": "HANDICAP",
                        "title": "Handicap (Regular Time)",
                        "side": ["Home", "Away"]
                    }
                ]
            ]
        },
        "default": {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "side": ["P1", "P2"]
                    }
                ], [
                    {
                        "display_key": "TOTALS",
                        "title": "TOTALS",
                        "side": ["Over", "Under"]
                    }
                ]
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "side": ["P1", "P2"]
                    }
                ], [
                    {
                        "display_key": "TOTALS",
                        "title": "TOTALS",
                        "side": ["Over", "Under"]
                    }
                ]
            ]
        }
    }
};